<template>
  <div class="change">
        <!-- logo -->
    <img src="@/assets/1/logo2.png" class="logo" />
    <img src="@/assets/1/bg1.jpg" class="bgImg" v-if="bg" />
         <img
      src="@/assets/1/xing.png"
      class="bgImg xing animated fadeIn"
      v-if="xing"
    />
    <img
      src="@/assets/1/xing.png"
      class="bgImg xing animated fadeIn"
      v-if="!xing"
    />
    <!--流星-->
    <div class="liuxing">
      <div class="lx lx1"></div>
      <div class="lx" v-show="lx2State" :class="{ lx2: lx2State }"></div>
      <div class="lx" v-show="lx3State" :class="{ lx3: lx3State }"></div>
      <div class="lx" v-show="lx4State" :class="{ lx4: lx4State }"></div>
      <div class="lx" v-show="lx5State" :class="{ lx5: lx5State }"></div>
      <div class="lx" v-show="lx6State" :class="{ lx6: lx6State }"></div>
    </div>
    <img src="@/assets/7/img1.png" class="img1 animated zoomIn" />
    <img src="@/assets/7/img2.png" class="img2 animated zoomIn" />
    <!-- 宇航员 -->
    <img src="@/assets/7/yu1.png" class="yu yu1" />
    <img src="@/assets/7/yu2.png" class="yu yu2" />
    <img src="@/assets/7/yu3.png" class="yu yu3" />
    <img src="@/assets/7/yu4.png" class="yu yu4" />
    <!-- 礼盒 -->
    <img src="@/assets/7/lihe.png" class="lihe animated zoomIn" />
    <img src="@/assets/7/img3.png" class="img3 animated rotateInUpRight" />
    <img src="@/assets/7/share.png" class="share" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      bg: true,
      icon: true,
      hua3: false,
      lx2State: false,
      lx3State: false,
      lx4State: false,
      lx5State: false,
      lx6State: false,
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      show6: false,
      show7: false,
      show8: false,
      show9: false,
      kuang: false,
      yu: false,
      yuImg: false,
      xing:true

    };
  },
  mounted() {
    this.liuxing();
       setInterval(() => {
      this.xing = !this.xing;
    }, 800);
  },
  methods: {
    liuxing() {
      setTimeout(() => {
        this.lx2State = true;
      }, 2000);
      setTimeout(() => {
        this.lx3State = true;
      }, 2500);
      setTimeout(() => {
        this.lx4State = true;
      }, 8000);
      setTimeout(() => {
        this.lx5State = true;
      }, 4000);
      setTimeout(() => {
        this.lx6State = true;
      }, 7000);
      setInterval(() => {
        this.$nextTick(() => {
          this.lx2State = false;
          this.lx3State = false;
        });
      }, 3000);
      setInterval(() => {
        this.$nextTick(() => {
          this.lx4State = false;
          this.lx5State = false;
          this.lx6State = false;
        });
      }, 3000);
      setInterval(() => {
        this.lx2State = true;
        this.lx3State = true;
      }, 4000);
      setInterval(() => {
        this.lx4State = true;
        this.lx5State = true;
        this.lx6State = true;
      }, 2000);
    },
  },
};
</script>
<style lang="less" scoped>
.logo{
  top: 0;
    left: 0;
    width: 60%;
}
.change {
  position: relative;
}
.bgImg {
  width: 100vw;
  position: fixed;
  z-index: -1;
  top: 0;
  left: 0;
  height: 100vh;
}
.bg(@url) {
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(@url);
}
.icon-div {
  position: relative;
  width: 100%;
  height: 200px;
}
.icon {
  position: absolute;
  bottom: auto;
  right: 5%;
  left: auto;
  top: 5%;
  width: 11vw;
  display: initial;
  z-index: 2;
  clear: both;
}
// 流星
.liuxing {
  width: 100vw;
  height: 100vh;
  position: relative;
  .lx {
    opacity: 0;
    position: absolute;
  }
  .lx1 {
    width: (13.8125rem/2) /* 221/16 */;
    height: (9.1875rem/2) /* 147/16 */;
    .bg("./img/p1-liuxing0.png");
    left: (1.875rem/2) /* 30/16 */;
    top: (31.25rem/2) /* 500/16 */;
    animation: lx1dong 5s linear;
  }

  .lx2 {
    width: (30.5rem/2) /* 488/16 */;
    height: (20.25rem/2) /* 324/16 */;
    .bg("./img/p1-liuxing1.png");
    left: (3.125rem/2) /* 50/16 */;
    top: -(3.125rem/2) /* 50/16 */;
    animation: lx1dong 4s linear;
  }

  .lx3 {
    width: (30.5rem/2) /* 488/16 */;
    height: (20.25rem/2) /* 324/16 */;
    .bg("./img/p1-liuxing1.png");
    left: 150px;
    top: 10px;
    animation: lx3dong 5s linear;
  }

  .lx4 {
    width: (30.5rem/2) /* 488/16 */;
    height: (20.25rem/2) /* 324/16 */;
    .bg("./img/p1-liuxing1.png");
    left: 0;
    top: 300px;
    animation: lx1dong 4s linear;
  }

  .lx5 {
    width: (30.5rem/2) /* 488/16 */;
    height: (20.25rem/2) /* 324/16 */;
    .bg("./img/p1-liuxing1.png");
    left: -100px;
    top: -80px;
    animation: lx3dong 3s linear;
  }

  .lx6 {
    width: (30.5rem/2) /* 488/16 */;
    height: (20.25rem/2) /* 324/16 */;
    .bg("./img/p1-liuxing1.png");
    left: 150px;
    top: 350px;
    animation: lx3dong 2s linear;
  }
}
@keyframes lx1dong {
  0% {
    transform: translate(-100px, 0);
    opacity: 1;
  }
  100% {
    transform: translate(750px, 600px);
    opacity: 1;
  }
}

.img1 {
  position: absolute;
  top: 18%;
  width: 80%;
  left: 10%;
}
.img2 {
  position: absolute;
  top: 26%;
  width: 70%;
  left: 15%;
  animation-delay: 1s;
  -webkit-animation-delay: 1s; /* Safari 和 Chrome */
}
.items {
  display: flex;
  position: absolute;
  top: 30%;
  width: 80%;
  left: 10%;
  justify-content: space-between;
}
.items .item-left,
.item-right {
  width: 45%;
}
.items div img {
  width: 100%;
}
.yuImg {
  position: relative;
  animation: mymove 3s infinite;
  -webkit-animation: mymove 3s infinite; /*Safari and Chrome*/
  animation-direction: alternate; /*轮流反向播放动画。*/
  animation-timing-function: ease-in-out; /*动画的速度曲线*/
  /* Safari 和 Chrome */
  -webkit-animation: mymove 3s infinite;
  -webkit-animation-direction: alternate; /*轮流反向播放动画。*/
  -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
}

.yu {
  position: absolute;
  width: 35vw;
  animation: mymove 3s infinite;
  -webkit-animation: mymove 3s infinite; /*Safari and Chrome*/
  animation-direction: alternate; /*轮流反向播放动画。*/
  animation-timing-function: ease-in-out; /*动画的速度曲线*/
  /* Safari 和 Chrome */
  -webkit-animation: mymove 3s infinite;
  -webkit-animation-direction: alternate; /*轮流反向播放动画。*/
  -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
}
.yu1 {
  top: 5vw;
  left: -2vw;
}
.yu2 {
  top: -10vw;
  right: -2vw;
}
.yu3 {
  bottom: 5vw;
  left: -5vw;
}
.yu4 {
  bottom: 5vw;
  right: -5vw;
}
.lihe {
  position: absolute;
  top: 30%;
  width: 90%;
  left: 5%;
  animation-delay: 2s;
  -webkit-animation-delay: 2s; /* Safari 和 Chrome */
}
.img3 {
  position: absolute;
  bottom: 25%;
  width: 60%;
  left: 20%;
}
.share {
  opacity: 0;
  position: absolute;
  width: 8vw;
  bottom: 40%;
  right: 0;
  animation: post-list-row 2s ease 2s infinite;
  -webkit-animation: post-list-row 2s ease 2s infinite;
}

@keyframes mymove {
  0% {
    transform: scale(1); /*开始为原始大小*/
  }
  25% {
    transform: scale(1.1); /*放大1.1倍*/
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.1);
  }
}

@-webkit-keyframes mymove /*Safari and Chrome*/ {
  0% {
    transform: scale(1); /*开始为原始大小*/
  }
  25% {
    transform: scale(1.1); /*放大1.1倍*/
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.1);
  }
}
@keyframes post-list-row {
  0% {
    opacity: 0;
    -webkit-transform: translateY(240px);
    transform: translateY(240px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: translateY(0) scale(0.9);
  }
}
@-webkit-keyframes post-list-row {
  0% {
    opacity: 0;
    -webkit-transform: translateY(240px);
    transform: translateY(240px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: translateY(0) scale(0.9);
  }
}
.xing{
  top: 30%;
  right: 0;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/end/end.vue